<form class="details-screen" #formRef="ngForm"> 
	<bb-page-header [backOnMobile]="['/publication/upload-credentials']" [icon]="'shield-keyhole'" [title]="uploadCredentials.label">
		<ul class="tabs">
			<li>
				<a class="active">
					<i class="fa fa-shield-keyhole"></i> {{ 'DETAILS' | translate }}
				</a>
			</li>
		</ul>
		<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status" 
			[valueOn]="'active'" [valueOff]="'draft'" [labelOn]="'ACTIVE' | translate" [labelOff]="'INACTIVE' | translate" ></bb-status>
	</bb-page-header>

	<div class="body-column" *ngIf="entity">
		<div class="left-column">
			<h3>{{'INFORMATION' | translate}}</h3>

			<bb-form-element [form]="form" label="{{'LABEL' | translate}}" [helpMessage]="'HELP.UPLOAD_CREDENTIALS_LABEL' | translate">
				<input required type="text" [(ngModel)]="entity.label" name="label" (keydown.space)="$event.preventDefault()"/>
			</bb-form-element>
			
			<bb-form-element [form]="form" label="{{'AWS_ACCESS_KEY_ID' | translate}}">
				<div class="input" >{{entity.awsaccesskeyid}}</div>
			</bb-form-element>

			<bb-form-element [form]="form" label="{{'S3_BUCKET_URL' | translate}}">
				<div class="input" >{{entity.s3BucketUrl}}</div>
			</bb-form-element>
		
			<bb-entity-details *ngIf="!isNew"
				[entity]="entity"
			></bb-entity-details>
		</div>
	</div>
</form>
<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form" [entity]="entity"></bb-actions-bar>
